import { LoaderPlugin } from "vue-google-login"
import Vue from "vue"

// google login
Vue.use(LoaderPlugin, {
  client_id: process.env.VUE_APP_GOOGLE_AUTH_ID
})

function getAuth2() {
  return Vue.GoogleAuth.then(auth2 => {
    return Promise.resolve(auth2)
    // Vue.prototype.$googleAuth2 = auth2
  }).catch(function(error) {
    return Promise.reject(error)
  })
}

export { getAuth2 }
